import { injectable, decorate, inject } from 'inversify';
import 'reflect-metadata';
import { SERVICE_IDENTIFIER } from 'constants/identifiers';
import { downloadFile } from 'utils/file';

@injectable()
class ProductService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  async getSuggestions(params) {
    const result = await this.apiService.get(
      '/products_search/suggest',
      params,
    );

    return result.data.data.items;
  }

  getPlants = async (params) => {
    const result = await this.apiService.get(
      '/products_search/distribution_centers',
      params,
    );

    return result.data.data.items;
  };

  async getProducts(params, axiosOptions) {
    const result = await this.apiService.get(
      '/products_search/list',
      params,
      axiosOptions,
    );

    return result.data.data.items;
  }

  async getSaleOrganizations(params) {
    const result = await this.apiService.get(
      '/products_search/sale_organizations',
      params,
    );

    return result.data.data.items;
  }

  async getProductInfo(productId) {
    const result = await this.apiService.get(
      `/products_search/${productId}/info`,
    );

    return result.data.data.items[0];
  }

  async getProductDescription(productId) {
    const result = await this.apiService.get(
      `/products_search/${productId}/description`,
    );

    return result.data.data.items[0];
  }

  async getProductCharacteristics(productId) {
    const result = await this.apiService.get(
      `/products_search/${productId}/characteristics`,
    );

    return result.data.data.items;
  }

  async getProductStocks(productId, abortSignal) {
    const result = await this.apiService.get(
      `/products_search/${productId}/stocks`,
      undefined,
      { signal: abortSignal },
    );

    return result.data.data.items;
  }

  getCalculatorDefaultValues = async (productId) => {
    const result = await this.apiService.get(
      `/products_search/${productId}/calculator/default_values`,
    );

    return result.data.data.items[0];
  };

  getCalculatorDefaultValuesV2 = async (productId, plantId, saleOrgId) => {
    const result = await this.apiService.get(
      `/products_search/${productId}/calculator/default_values_v2?plantId=${plantId}&saleOrgId=${saleOrgId}`,
    );

    return result.data.data.items[0];
  };

  calculatePrice = async (productId, formData) => {
    const result = await this.apiService.post(
      `/products_search/${productId}/calculator`,
      formData,
    );

    return result.data.data.items[0];

    // return {
    //   quantity: 100,
    //   price: 181.26,
    //   priceTotal: 18126,
    //   stopPrice: 5,
    //   cost: 60.42,
    //   costTotal: 6042,
    //   profitTotal: 10070,
    //   markup: 200,
    // };
  };

  getUnits = async (productId) => {
    const result = await this.apiService.get(
      `/products_search/${productId}/units`,
    );

    return result.data.data.items;
  };

  async convertUnits(productId, data) {
    const result = await this.apiService.post(
      `/products_search/${productId}/convert_units`,
      data,
    );

    return result.data.data.items[0];
  }

  async getCertificateTypes() {
    const result = await this.apiService.get(
      `/products_search/certificate_types`,
    );

    return result.data.data.items;
  }

  async getCertificates(productId, axiosOptions) {
    const result = await this.apiService.get(
      `/products_search/${productId}/certificates`,
      undefined,
      axiosOptions,
    );

    return result.data.data.items;
  }

  async downloadCertificate(certificateId) {
    const result = await this.apiService.get(
      `/products_search/certificates/${certificateId}`,
      {},
      { responseType: 'blob' },
    );
    const filename = decodeURI(
      result.headers['content-disposition'].split("''")[1],
    );

    downloadFile(result.data, filename);
  }
}

decorate(inject(SERVICE_IDENTIFIER.ApiService), ProductService, 0);

export default ProductService;
